import { Divider, MenuItem, Stack, TextField, Typography } from "@mui/material";
import { orderBy } from "../../utils/lodash-replacements";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useActiveFBOs } from "../../containers/ActiveFBOContainer";
import { scrollSx } from "../../utils";
import { AddFBO } from "../../widgets/AddFBO";
import { ButtonRemoveFBO } from "../Settings/UberAdmin/ButtonRemoveFBO";
import { EditFboName } from "./EditFboName";

type Props = {};

export const FBOAdmin: React.FC<Props> = () => {
  const { t } = useTranslation();
  const { fbos, setFBO } = useActiveFBOs();
  const sortedFBOs = React.useMemo(() => {
    return orderBy(fbos, ["name"], ["asc"]);
  }, [fbos]);

  return (
    <Stack direction="column" spacing={4} sx={{ width: 400, p: 1 }}>
      <Stack direction="column" spacing={1}>
        <Stack direction="column">
          <Typography>{t("screens.fboAdmin.seriousBusiness.title")}</Typography>
          <Typography variant="caption" color="textSecondary">
            {t("screens.fboAdmin.seriousBusiness.subtitle")}
          </Typography>
        </Stack>
        <Divider />
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography>{t("screens.fboAdmin.addFboLabel")}</Typography>
          <AddFBO />
        </Stack>
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography dangerouslySetInnerHTML={{ __html: t("screens.fboAdmin.deleteFboLabel") }} />
          <ButtonRemoveFBO />
        </Stack>
      </Stack>

      <Stack direction="column" spacing={1}>
        <Stack direction="column">
          <Typography>{t("screens.fboAdmin.currentFbos.title")}</Typography>
          <Typography variant="caption" color="textSecondary">
            {t("screens.fboAdmin.currentFbos.subtitle")}
          </Typography>
        </Stack>
        <Divider />
        <Stack
          direction="column"
          spacing={1}
          maxHeight={450}
          overflow="auto"
          p={1}
          sx={{ ...scrollSx }}
        >
          {sortedFBOs.map((fbo) => (
            <Stack
              key={`fbo-${fbo.id}`}
              direction="row"
              spacing={1}
              alignItems="center"
            >
              <EditFboName
                name={fbo?.name}
                onChange={(name) => {
                  setFBO({
                    ...fbo,
                    name: name,
                  });
                }}
              />
              <TextField
                size="small"
                select
                fullWidth
                label={t("screens.fboAdmin.subscriptionLabel")}
                value={fbo.subscription}
                onChange={(evt) => {
                  setFBO({
                    ...fbo,
                    subscription: evt.target.value as any,
                  });
                }}
              >
                <MenuItem value={"standard"}>{t("screens.fboAdmin.subscriptions.standard")}</MenuItem>
                <MenuItem value={"autostacking"}>{t("screens.fboAdmin.subscriptions.autostacking")}</MenuItem>
                <MenuItem value={"autostacking_with_edit"}>
                  {t("screens.fboAdmin.subscriptions.autostackingWithEdit")}
                </MenuItem>
                <MenuItem value={"autostacking_with_edit_and_copy"}>
                  {t("screens.fboAdmin.subscriptions.autostackingWithEditAndCopy")}
                </MenuItem>
                <MenuItem value={"inactive"}>{t("screens.fboAdmin.subscriptions.inactive")}</MenuItem>
              </TextField>
              <TextField
                size="small"
                fullWidth
                label={t("screens.superAdmin.emailSlugLabel")}
                value={fbo.email_slug || ""}
                InputProps={{
                  readOnly: true,
                }}
                sx={{ maxWidth: 200 }}
              />
            </Stack>
          ))}
        </Stack>
      </Stack>
    </Stack>
  );
};
